import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { buildApiUrl } from "../config/api";

function ApiPage() {
  const navigate = useNavigate();
  const [prompt, setPrompt] = useState(
    "Give me my top spend categories and how to reduce costs.",
  );
  const [result, setResult] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function getInsight() {
    const token = localStorage.getItem("token");
    const email = localStorage.getItem("email");

    if (!token || !email) {
      navigate("/");
      return;
    }

    setLoading(true);
    setError("");
    setResult("");

    try {
      const res = await fetch(buildApiUrl("record/ai-insight"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token,
        },
        body: JSON.stringify({ email, prompt }),
      });

      const data = await res.json();

      if (!res.ok) {
        if (res.status === 401 || res.status === 403) {
          localStorage.removeItem("token");
          localStorage.removeItem("islogin");
          navigate("/");
          return;
        }
        setError(data?.message || "Failed to fetch AI insight");
        return;
      }

      setResult(data?.insight || "No insight generated");
    } catch (e) {
      setError("Failed to call AI");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="container">
      <div className="leftcontainer">
        <div className="graphCard">
          <h2>AI Expense Insights</h2>
          <p>Ask the AI to analyze your expense records.</p>
          <textarea
            className="apiTextArea"
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            placeholder="Type your analysis request"
          />
          <button type="button" onClick={getInsight} disabled={loading}>
            {loading ? "Analyzing..." : "Run AI"}
          </button>
          {error ? <p style={{ color: "red" }}>{error}</p> : null}
          {result ? <pre className="apiResult">{result}</pre> : null}
        </div>
      </div>

      <div className="rightcontainer">
        <div className="formcard">
          <h2>Navigation</h2>
          <button type="button" onClick={() => navigate("/dashboard")}>
            Back to Dashboard
          </button>
          <button
            type="button"
            onClick={() => navigate("/dashboard/graph")}
            style={{ marginTop: "10px" }}
          >
            Open Graph
          </button>
        </div>
      </div>
    </div>
  );
}

export default ApiPage;
